import {Box, BoxFillIcon, FullscreenPanel, FullscreenPanelBody, Paper, Pvz2FillIcon} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, memo, useMemo, useState} from 'react'
import {useFormContext} from 'react-hook-form'

import {renderWidget} from '..'
import type {AddressWidgetProps} from '../types'
import {PointModal} from './PointModal/PointModal'
import {PointSlot} from './PointSlot/PointSlot'
import type {PickupTarget} from './types'

type Props = {
  config: AddressWidgetProps['config']
  name: string
}
type State = {
  target: PickupTarget
  opened: boolean
}

export const PickupRoute = memo<Props>(function PickupRoute({name, config}: Props): ReactElement | null {
  const i18n = useI18n()
  const {watch} = useFormContext()
  const [state, setState] = useState<State>({
    target: 'source',
    opened: false,
  })

  const SlotTrail = useMemo(
    () => (
      <Box alignItems="center" gap="xs">
        {config.trail && renderWidget(config.trail)}
        {config.trail2 && renderWidget(config.trail2)}
      </Box>
    ),
    [config.trail, config.trail2],
  )

  if (config.route_point_index > 1) {
    return null
  }

  const target = config.route_point_index === 0 ? 'source' : 'destination'
  const isDestination = config.route_point_index !== 0
  const isDisabledPointTypeDestination = isDestination && watch('ndd.route.source.pickupPoint') === undefined

  return (
    <Paper mt={undefined} item>
      <Paper mt={undefined} item>
        <PointSlot
          key={target}
          isDestination={isDestination}
          lead={isDestination ? <Pvz2FillIcon /> : <BoxFillIcon />}
          name={`${name}.${target}`}
          onPress={() => {
            if (isDisabledPointTypeDestination) {
              return
            }
            setState({opened: true, target})
          }}
          text={
            isDestination
              ? i18n('bdui.pickup_points.placeholder.receive', 'Доставить')
              : i18n('bdui.pickup_points.placeholder.send', 'Отправить')
          }
          trail={SlotTrail}
        />
      </Paper>
      <FullscreenPanel anchor="bottom" color="minor" opened={state.opened}>
        <FullscreenPanelBody>
          <PointModal
            key={state.target}
            name={`${name}.${state.target}`}
            onClose={() => {
              setState({target: state.target, opened: false})
            }}
            onContinue={() => {
              setState({target: 'destination', opened: state.target === 'source'})
            }}
            target={state.target}
          />
        </FullscreenPanelBody>
      </FullscreenPanel>
    </Paper>
  )
})
